import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { ammControlloFormValidators } from '../../validators/amm-controllo-common.form-validators';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { normeSpaMonisticoAssembleaTipoAmmRules } from './norme-spa-monistico-assemblea-tipo-amm.rules';
import { normeSpaMonisticoOrganoControlloRules } from './norme-spa-monistico-organo-controllo.rules';
import { normeSpaMonisticoComitGestRules } from './norme-spa-monistico-comit-gest.rules';

export const NormeSpaMonisticoRules: FormGroupRules = {
    ...normeSpaMonisticoAssembleaTipoAmmRules,
    ...normeSpaMonisticoOrganoControlloRules,
    ...normeSpaMonisticoComitGestRules,
};

export const NormeSpaMonisticoFormValidators = [...Object.values(NormeSpaMonisticoRules), ...ammControlloFormValidators(CkNormeValuesEnum.normeSpaMonistico)];
